import { createStore as createReduxStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "react-router-redux";

import history from "../browserHistory";

import rootReducer from "./reducers";
import rootSaga from "./sagas";

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const router = routerMiddleware(history);
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
  const store = createReduxStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, router))
  );
  sagaMiddleware.run(rootSaga);

  if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept("./reducers", () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

export default createStore();
